export default (containerSelector, titleSelector) => (event) => {
  const select = event.target
  const exportElement = event.target.closest(containerSelector)

  const title = exportElement.querySelector(titleSelector)

  requestAnimationFrame(() => {
    title.style.display = 'block'
    title.value = select.options[select.selectedIndex].text
  })
}
